import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { CancelarVisitaMasivaComponent } from './cancelar-visita-masiva.component';
import { TablaCancelarAgendaComponent } from './tabla-cancelar-agenda.component';
import { CancelarVisitaMasivaRoutingModule } from './cancelar-visita-masiva-routing.module';


@NgModule({
    declarations: [CancelarVisitaMasivaComponent, TablaCancelarAgendaComponent],
    imports: [
        SharedModule,
        CommonModule,
        CancelarVisitaMasivaRoutingModule
    ],
    exports: [CancelarVisitaMasivaComponent, TablaCancelarAgendaComponent]
})
export class CancelarVisitaMasivaModule { }
